// extracted by mini-css-extract-plugin
module.exports = {"stay-booked__header":"StayBooked_stay-booked__header__1vYXV","stay-booked":"StayBooked_stay-booked__miBjP","stay-booked__content":"StayBooked_stay-booked__content__vM9m_"};